import Events from "../Events";
import io from "socketio";
import UIModal from "../modals/UIModal";
import langDictionary from "../lang/init";
import "../../plugins/jquery.cookie";


let socket = io();
window.socket = socket;

let client = new Events();

client.onSocketError = function(err) {
    UIModal.error(langDictionary.getError("socket_error"));
    console.error(err);
};

// прослойка для обработки данных
client.subscribeTo = function(path, callback) {
    socket.on(path, function(e) {
        let type = null;
        let data = null;
        let user = null;

        if ( e && e.ev ) {
            data = e.ev.data;
            type = e.ev.type;
            // user { id - ид пользователя в базе, login - логин }
            user = e.ev.user;
        }

        callback(type, data, user);
    });
};

// быстрая подписка на события таблицы
client.subscribeOnTable = function(tableName, callback) {
    client.subscribeTo("/table/" + tableName, function(type, data) {
        callback(type, data);
    });
};

client.emit = function(/* event, params */) {
    socket.emit.apply(socket, arguments);
};

client.on = function(eventName, callback) {
    Events.prototype.on.call(this, eventName, callback);
    socket.on(eventName, function() {
        let args = [eventName].concat([].slice.call(arguments));
        this.trigger.apply(this, args);
    }.bind(this));
};

/**
     * Отладочный метод для реконфигурации сокета с клиента
     * @param  { object | Socket} config - новая конфигурация для сокета выделенного на сервере, может быть задана экземляром Socket из Socket.io
     * @param  { string } config.deviceType - тип устройства
     * @param  { bool } config.selfBroadcast - вещание на себя, передает вснесеные через апи изменения на сокет клиента  //Параметр для имитации наших извращений с сокетами
     *
     */
client.setConfig = function(config) {
    socket.emit("setConfig", config);
};

export default client;
